import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ObjectToNumeratedArrayPipe',
    pure: false,
    standalone: false,
})
export class ObjectToNumeratedArrayPipe implements PipeTransform {
    public transform(value: object, _: [] = null): string[] {
        if (value !== undefined && value !== null) {
            return Object.keys(value);
        }
    }
}
